import { render, staticRenderFns } from "./anonymous-corruption-report.vue?vue&type=template&id=630cfa0b&scoped=true"
import script from "./anonymous-corruption-report.vue?vue&type=script&lang=js"
export * from "./anonymous-corruption-report.vue?vue&type=script&lang=js"
import style0 from "./anonymous-corruption-report.vue?vue&type=style&index=0&id=630cfa0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630cfa0b",
  null
  
)

export default component.exports